import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _Entailment } from '../../../../core/services/dataBean/EntityCatalog';
import { _FactorNameList } from '../../../../core/services/dataBean/EntityCatalogVdos';

interface Props {
    idSelector: string;
    onChange: any;
    label?: string;
    year?: any;
    valueType?: any,
    fornightType?: any
}

export const PayrollFactorNameList = ({ idSelector, onChange, label, year, valueType, fornightType }: Props) => {
    const payrollname = useDataBean(_FactorNameList);
    const [lista, setLista] = useState<string[]>([]);
    const [id, setID] = useState<string>(idSelector?.toString() ?? '');

    useEffect(() => {
        getLista();
    }, [year, valueType, fornightType]);

    useEffect(() => {
        if (idSelector?.toString() !== id) {
            setID(idSelector?.toString() ?? '');
        }
    }, [idSelector]);

    const setValue = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedValue = e.target.value;
        setID(selectedValue);
        onChange(selectedValue); // se envía como string
    };

    const getLista = () => {
        payrollname.instance.getPayrollFactorNameList(year, valueType, fornightType).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp);
                } else {
                    setLista([]);
                }
            }
        );
    };

    return (
        <>
            <label>{label ?? "Factor Salarial:"}</label>
            <select className="form-select" value={id} onChange={setValue}>
                <option value="">...</option>
                {lista.map((item: string, index: number) => (
                    <option key={index} value={item}>
                        {item}
                    </option>
                ))}
            </select>
        </>
    );
};